import '../../styles/sass/global/components/home.scss';
import React, { useState } from 'react';
import UserProfile from '../../partials/layout/UserProfile';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import NotFoundRedirect from '../../components/route/NotFoundRedirect';
// import { CardsSVG } from '../../components';
import { ClientSVG, ManagmentSVG, UsersSVG } from '../../components';
import { Button } from '@mui/material';
import { Clients, Details, Address, Device, Telephones, PaymentLinksPosition } from '../../pages/clients';
import { Checker } from '../../pages/checker';
import { Products } from '../../pages/products';
import { Cancellations } from '../../pages/cancellations';
import { Summaries } from '../../pages/summaries';
import { Movements } from '../../pages/movements';
import { Users } from '../../pages/users';
import { PaymentLinks } from '../../pages/paymentLinks';
import { PaymentMovements } from '../../pages/paymentMovements';
import Consultants from '../../pages/consultants/Consultants';
import enabledPages from '../../constants/pages/enabledPages';
import { useTranslation } from 'react-i18next';
import { ClientUIProvider } from '../../pages/clients/profile/context/ClientByIdUIContext';
import { Collections } from '../../pages/collections';
import { Expirations } from '../../pages/expirations';
import Email from '../../pages/clients/profile/Email';
import { FraudPrevention } from '../../pages/fraudPrevention';
import ConsultantsList from '../../pages/consultants/ConsultantsList';
import { checkPermissions, getDefaultFallbackPath } from '../../helpers/PermissionsChecker';
import ProtectedRoute from '../../pages/auth/ProtectedRoute';
import { palette } from '../../styles/theme';

import { WalletSVG } from '../../components/svg/WalletSVG';
import permissionsMap from '../../constants/permissions/routePermissions';
import CustomPopper from '../../components/Popper';
import { ROUTES } from '../../constants/routes/routes';

export const Sidebar = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const currentPath = location.pathname;
    const defaultFallbackPath = getDefaultFallbackPath();

    const anchorRefs = React.useRef({});
    const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
    const [popperOpen, setPopperOpen] = useState(false);

    const routes = [
        {
            path: '/clients',
            active: currentPath.startsWith('/clients'),
            permissionToCheck: 'show_clients.main',
            key: 1,
            icon: <ClientSVG customStroke={palette.icons} strokeWidth='1.3' />, // Use palette reference
            iconHover: <ClientSVG customStroke='white' strokeWidth='1.3' />,
            label: t('clients.title')
        },
        {
            path: ROUTES.PRODUCTS.PAYMENT_LINKS.BASE,
            label: t('products.title'),
            permissionToCheck: 'show_products.show_links.main',
            icon: <WalletSVG style={{ stroke: currentPath.startsWith(ROUTES.PRODUCTS.BASE) ? palette.white : palette.icons, height: '1.846rem', width: '1.846rem', strokeWidth: '1.3' }} />,
            iconHover: <WalletSVG style={{ stroke: 'white', height: '24px', width: '24px', strokeWidth: '1.3' }} />,
            hasSubmenu: false,
            key: 7,
            active: currentPath.startsWith(ROUTES.PRODUCTS.BASE),
        }, {
            path: '/users',
            active: currentPath.startsWith('/users'),
            permissionToCheck: 'show_users',
            key: 2,
            icon: <UsersSVG customStroke={palette.icons} strokeWidth='1.3'/>,
            iconHover: <UsersSVG customStroke='white' strokeWidth='1.3'/>,
            label: t('users.title')
        }, {
            path: '/managment',
            active: currentPath.startsWith('/managment'),
            permissionToCheck: 'show_management.main',
            key: 4,
            icon: <ManagmentSVG customStroke={palette.icons} strokeWidth='1.3'/>,
            iconHover: <ManagmentSVG customStroke='white' strokeWidth='1.3'/>,
            label: t('management.title')
        }
    ];

    const isEnabled = (key) => {
        const flagName = permissionsMap[key];
        return flagName ? enabledPages[flagName] : true;
    };

    const filterRoutesWithPermissions = (allRoutes) => {
        return allRoutes.reduce((filteredRoutes, route) => {
            const isParentWithSubmenu = route.hasSubmenu && Array.isArray(route.submenu);

            if (isParentWithSubmenu) {
                const visibleSubmenuItems = route.submenu.filter((submenuItem) => isEnabled(submenuItem.key));

                if (visibleSubmenuItems.length > 0) {
                    filteredRoutes.push({ ...route, submenu: visibleSubmenuItems });
                }
            }
            else {
                const isRouteEnabled = isEnabled(route.key);

                if (isRouteEnabled) {
                    filteredRoutes.push(route);
                }
            }

            return filteredRoutes;
        }, []);
    };

    const filteredRoutes = filterRoutesWithPermissions(routes);

    const productRoute = filteredRoutes.find(r => r.hasSubmenu);
    const items = productRoute?.submenu?.length ? productRoute.submenu : [];

    const handleRoute = (path) => {
        history.push(path);
    };

    return (
        <ClientUIProvider>
            <div className='pages'>
                <div className='menu'>
                    <UserProfile history={history} t={t} />
                    {filteredRoutes.map(route => {
                        const isCurrentRoute = route.active;
                        const hasPermission = checkPermissions(route.permissionToCheck);
                        if (!hasPermission) return null;

                        const isSubmenu = route.hasSubmenu;

                        if (isSubmenu) {
                            return (
                                <div
                                    className='menu_component'
                                    key={route.key}
                                    ref={el => (anchorRefs.current[route.key] = el)}
                                    onMouseEnter={(e) => {
                                        setSubmenuAnchorEl(anchorRefs.current[route.key]);
                                        setPopperOpen(true);
                                    }}
                                    onMouseLeave={() => {
                                        setPopperOpen(false);
                                        setSubmenuAnchorEl(null);
                                    }}
                                >
                                    <Button
                                        className= {isCurrentRoute ? 'menu_button--active' : 'menu_button'}
                                    >
                                        <div className='menu_icon'>{route.icon}</div>
                                    </Button>
                                    <div className='menu_text'>{route.label}</div>
                                </div>
                            );
                        }

                        return (
                            <div className='menu_component' key={route.key}>
                                <Button
                                    className= {isCurrentRoute ? 'menu_button--active' : 'menu_button'}
                                    onClick = { () => handleRoute(route.path)}
                                >
                                    <div className='menu_icon'>{isCurrentRoute ? route.iconHover : route.icon}</div>
                                </Button>
                                <div className='menu_text'>{route.label}</div>
                            </div>);
                    })}

                    {/* Products Submenu Popper */}
                    <CustomPopper
                        state={{ popperOpen, setPopperOpen }}
                        items={items}
                        anchorElement={submenuAnchorEl}
                    />
                </div>
                <Switch>

                    {/* Redirect from root URL to /clients. */}
                    <Redirect exact from="/" to={defaultFallbackPath} />
                    <Redirect exact from="/managment" to="/managment/checker" />
                    <Redirect exact from="/cards" to={ROUTES.PRODUCTS.CARDS} />
                    {/* <ClientUIProvider> */}

                    <ProtectedRoute
                        path="/clients/details/address/:id"
                        isPageEnabled={enabledPages.enableClients}
                        component={Address}
                        action="show_clients.sub_address"
                    />

                    <ProtectedRoute
                        path="/clients/details/email/:id"
                        isPageEnabled={enabledPages.enableClients}
                        component={Email}
                        action="show_clients.sub_email"
                    />
                    <ProtectedRoute
                        path="/clients/details/mobile/:id"
                        isPageEnabled={enabledPages.enableClients}
                        component={Telephones}
                        action="show_clients.sub_telephones"
                    />

                    <ProtectedRoute
                        path="/clients/details/device/:id"
                        isPageEnabled={enabledPages.enableClients}
                        component={Device}
                        action="show_clients.sub_device"
                    />

                    <ProtectedRoute
                        path="/clients/details/:id"
                        isPageEnabled={enabledPages.enableClients}
                        component={Details}
                        action="show_clients.sub_details"
                    />
                    <ProtectedRoute
                        path="/clients/paymentLinksPosition/:id"
                        isPageEnabled={enabledPages.enableClients}
                        component={PaymentLinksPosition}
                        action="show_clients.sub_links"
                    />
                    {/* </ClientUIProvider> */}

                    <ProtectedRoute exact path="/clients"
                        component={Clients}
                        isPageEnabled={enabledPages.enableClients}
                        action='show_clients.main'
                    />
                    <ProtectedRoute exact path="/managment/checker"
                        component={Checker}
                        isPageEnabled={enabledPages.enableChecker}
                        action='show_management.sub_cancellations'
                    />

                    <ProtectedRoute
                        exact
                        path={ROUTES.PRODUCTS.CARDS.BASE}
                        isPageEnabled={enabledPages.enableProduct}
                        component={Products}
                        action='show_products.show_cards.main'
                    />
                    <ProtectedRoute
                        exact
                        path={ROUTES.PRODUCTS.CARDS.CANCELLATIONS}
                        isPageEnabled={enabledPages.enableProduct}
                        component={Cancellations}
                        action='show_products.show_cards.sub_cancellations'
                    />
                    <ProtectedRoute
                        exact
                        path={ROUTES.PRODUCTS.CARDS.MOVEMENTS}
                        isPageEnabled={enabledPages.enableProduct}
                        component={Movements}
                        action='show_products.show_cards.sub_movements'
                    />
                    <ProtectedRoute
                        exact
                        path={ROUTES.PRODUCTS.CARDS.SUMMARIES}
                        isPageEnabled={enabledPages.enableProduct}
                        component={Summaries}
                        action='show_products.show_cards.sub_summaries'
                    />
                    <ProtectedRoute
                        exact
                        path={ROUTES.PRODUCTS.CARDS.COLLECTIONS}
                        isPageEnabled={enabledPages.enableProduct}
                        component={Collections}
                        action='show_products.show_cards.sub_collections'
                    />
                    <ProtectedRoute
                        exact
                        path={ROUTES.PRODUCTS.CARDS.EXPIRATIONS + '/:id'}
                        isPageEnabled={enabledPages.enableProduct}
                        component={Expirations}
                        action='show_products.show_cards.sub_expirations'
                    />
                    <ProtectedRoute
                        exact
                        path='/users'
                        isPageEnabled={enabledPages.enableProduct}
                        component={Users}
                        action='show_users'
                    />
                    <ProtectedRoute
                        exact
                        path={ROUTES.PRODUCTS.PAYMENT_LINKS.BASE}
                        component={PaymentLinks}
                        isPageEnabled={enabledPages.enablePaymentLinks}
                        action='show_products.show_links.main'
                    />
                    <ProtectedRoute
                        exact
                        path={ROUTES.PRODUCTS.PAYMENT_LINKS.BASE + '/:id'}
                        component={PaymentLinks}
                        isPageEnabled={enabledPages.enablePaymentLinks}
                        action='show_products.show_links.sub_payments'
                    />
                    <ProtectedRoute
                        exact
                        path={ROUTES.PRODUCTS.PAYMENT_LINKS.MOVEMENTS}
                        component={PaymentMovements}
                        isPageEnabled={enabledPages.enablePaymentMovements}
                        action='show_products.show_links.sub_payments'
                    />
                    <ProtectedRoute
                        exact
                        path='/managment/consultants'
                        component={ConsultantsList}
                        isPageEnabled={enabledPages.enableProduct}
                        action='show_management.sub_consultants'
                    />
                    <ProtectedRoute
                        exact
                        path='/managment/consultants/load'
                        component={Consultants}
                        isPageEnabled={enabledPages.enableProduct}
                        action='show_management.sub_consultants_load'
                    />
                    <ProtectedRoute
                        exact
                        path='/managment/fraudPrevention'
                        component={FraudPrevention}
                        isPageEnabled={enabledPages.enableProduct}
                        action='show_management.sub_antifraud'
                    />
                    <Route
                        path='*'
                        render={() => (
                            <NotFoundRedirect
                                fallbackPath={defaultFallbackPath}
                            />
                        )}
                    />
                </Switch>
            </div>
        </ ClientUIProvider>
    );
};

export default Sidebar;
